import { Banner, Header } from 'Components/main_components/wallet/currency_home';
import { Tab, TabPanel, Tabs } from 'Components/shared/tab';
import TableDisplay from 'Components/shared/table';
import Text from 'Components/shared/text';
import { Status, TransactionType } from 'Components/shared/transactions';
import React, { useEffect, useMemo, useState } from 'react'

import { useNavigate, useParams } from 'react-router-dom'
import { useGetUsersTransactions } from 'services/transactionService';
import { currencyMap } from 'utils/constants/maps';

import { capitalize, convertDate } from 'utils/stringServices';

import styles from './wallet.module.css'

const format = Intl.NumberFormat("en-US");
const dateFormat = Intl.DateTimeFormat("en-GB");

const convertServerDate = (str) => {
    if(!str || typeof str !== "string") return str
    return str.split(" ").join("T")
}
const tableStructure = {
    0: {
        field:"transactionType",
        renderItem:(rowData) => (
            <TransactionType type={rowData?.type === "deposit" ? "credit" : (rowData?.type === "withdraw" ? "debit": (rowData?.type === "swap" ? "swap" :""))} /> 
        ),
        cellStyle:{},
    },
    1:{
        renderItem: rowData => (
            <Text style={{fontWeight:"300"}}>{capitalize(rowData.type)}: <br /> {rowData.details || "Payment Id: 234565666766"}</Text>
        ),
        cellStyle:{
            minWidth: "220px",

        }
    },
    2:{
        renderItem: rowData => (
            <Text style={{fontWeight:"300"}}>Date:<br /> {convertDate(rowData.timestamp)}</Text>
        ),
        cellStyle:{
            minWidth: "110px"
        }  
    },
    3:{
        renderItem: rowData => (
            <Status variant={rowData.status == "ok" ? "completed":"pending"} />
        ),
        cellStyle:{
            textAlign:"left",

        }    
    },
    4:{
        renderItem: rowData => (
            <Text style={{display:"flex",
            alignItems: "center",
            justifySelf:"flex-end"}}>
            {`${currencyMap[rowData.currency?.toLowerCase?.()] || "$"}
            ${format.format(rowData.amount)}`}</Text>
        ),
        cellStyle:{
            display:"flex",
            alignItems: "center",
            justifyContent: "flex-end",
            justifySelf:"flex-end",
            minWidth:"120px",
            flexGrow:2,
            paddingRight:"24px"
        }  
    }
}
const WalletCurrency = (props) => {
    const { currency} = useParams();

    const navigate = useNavigate();
    const [selectedTab, setSelectedTab] = useState(0);
    const {data: depositTransactions} = useGetUsersTransactions("deposit");
    const {data: withdrawTransactions} = useGetUsersTransactions("withdraw");
   
    const handleChange = (e, tabIndex) => {
        setSelectedTab(tabIndex);
    }
    const allTransactions = useMemo(() => {
       const res = depositTransactions?.concat(withdrawTransactions);
       return res?.sort((a,b) => new Date(convertServerDate(a.timestamp)) - new Date(convertServerDate(b.timestamp)) );
    }, [depositTransactions?.length, withdrawTransactions?.length])
    console.log(depositTransactions, withdrawTransactions, allTransactions);

    return (
      <div className={styles.root} >
          <Header currency={currency} />
          <Banner currency={currency} />

          <div className={styles.contentContainer}>
                <Text variant="md2" tag="h2" style={{ fontWeight:"700",marginBottom:"24px"}}>Transactions</Text>
                <Tabs value={selectedTab} handleChange={handleChange} fullWidth>
                    <Tab label="All" />
                    <Tab label="Credit" />
                    <Tab label="Debit" />
                </Tabs>
                <TabPanel value={selectedTab} index={0}  >
                   <TableDisplay data={allTransactions || []} column={tableStructure}  />
                </TabPanel>
                <TabPanel value={selectedTab} index={1} >
                    <TableDisplay data={depositTransactions || []} column={tableStructure} 
                    
                    emptyComponent="No records yet" />
                </TabPanel>
                <TabPanel value={selectedTab} index={2} >
                <TableDisplay data={withdrawTransactions || []} column={tableStructure} 
                
                emptyComponent="No records yet" />
                </TabPanel>
            </div>
      </div>
    )
}

export default WalletCurrency